import { createReducer } from '@reduxjs/toolkit'
import { getETHAddress, getTHEAddress } from '../../utils/addressHelpers'
import {
  addBookMarkPair,
  addBookMarkToken,
  removeBookmarkPair,
  removeBookmarkToken,
  updateBlockNumber,
  updateBookmarkPairs,
  updateBookmarkTokens,
  addImportedToken,
  removeImportedToken,
  clearImportedToken,
  updateSwapType,
  updateFromToken,
  updateToToken,
} from './actions'

const initialState = {
  blockNumber: {},
  bookmarkedTokens: [],
  bookmarkedPairs: [],
  importedTokens: [],
  swapType: 'SWAP',
  fromToken: getETHAddress(),
  toToken: getTHEAddress(),
}

export default createReducer(initialState, (builder) =>
  builder
    .addCase(updateBlockNumber, (state, action) => {
      const { chainId, blockNumber } = action.payload
      state.blockNumber[chainId] = blockNumber
    })
    .addCase(addBookMarkToken, (state, { payload }) => {
      const tokens = state.bookmarkedTokens
      tokens.push(payload)
      state.bookmarkedTokens = tokens
    })
    .addCase(removeBookmarkToken, (state, { payload }) => {
      const tokenIndex = state.bookmarkedTokens.indexOf(payload)
      const tokens = state.bookmarkedTokens.slice(0, tokenIndex - 1).concat(state.bookmarkedTokens.slice(tokenIndex + 1, state.bookmarkedTokens.length - 1))
      state.bookmarkedTokens = tokens
    })
    .addCase(updateBookmarkTokens, (state, { payload }) => {
      state.bookmarkedTokens = payload
    })
    .addCase(addBookMarkPair, (state, { payload }) => {
      const pairs = state.bookmarkedPairs
      pairs.push(payload)
      state.bookmarkedPairs = pairs
    })
    .addCase(removeBookmarkPair, (state, { payload }) => {
      const pairIndex = state.bookmarkedPairs.indexOf(payload)
      const pairs = state.bookmarkedPairs.slice(0, pairIndex - 1).concat(state.bookmarkedPairs.slice(pairIndex + 1, state.bookmarkedPairs.length - 1))
      state.bookmarkedPairs = pairs
    })
    .addCase(updateBookmarkPairs, (state, { payload }) => {
      state.bookmarkedPairs = payload
    })
    .addCase(addImportedToken, (state, { payload }) => {
      const tokens = state.importedTokens
      tokens.push(payload)
      state.importedTokens = tokens
    })
    .addCase(removeImportedToken, (state, { payload }) => {
      const tokenIndex = state.importedTokens.indexOf(payload.address)
      const tokens = state.importedTokens.slice(0, tokenIndex - 1).concat(state.importedTokens.slice(tokenIndex + 1, state.importedTokens.length - 1))
      state.importedTokens = tokens
    })
    .addCase(clearImportedToken, (state) => {
      state.importedTokens = []
    })
    .addCase(updateSwapType, (state, { payload }) => {
      state.swapType = payload
    })
    .addCase(updateFromToken, (state, { payload }) => {
      state.fromToken = payload
    })
    .addCase(updateToToken, (state, { payload }) => {
      state.toToken = payload
    }),
)
